import { useEffect, useState } from 'react'
import { InputTextSaveCell } from '@pages/Admin/Reports/Payments/components/Cells/Cells'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import { ScorePercentageProps } from '../../utils/types'
import styles from '../../index.module.css'

const ScorePercentage = ({ lesson, onSave }: ScorePercentageProps) => {
  const [percent, setPercent] = useState(String(lesson.progress ?? 0))

  useEffect(() => {
    setPercent(String(lesson.progress ?? 0))
  }, [lesson.progress])

  return (
    <TooltipWrapper
      title="Можете указать пользователю успех прохождения урока, Кр или пробника. В таком случае система автоматически посчитает, что пользователь выполнил задание на N%."
      placement="top"
    >
      <div className={styles.progressInputWrapper}>
        <InputTextSaveCell
          value={percent}
          className={styles.progressInput}
          styles={{ backgroundColor: 'white' }}
          onChange={(value) => {
            const nextPercent = Number(value)
            if (nextPercent < 0 || nextPercent > 100) return
            setPercent(String(value))
          }}
          onSave={() => onSave(lesson, Number(percent))}
          type="number"
        />
      </div>
    </TooltipWrapper>
  )
}

export default ScorePercentage
